/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Menuscannocharge3Inputs */

const en_menuscannocharge3 = /** @type {(inputs: Menuscannocharge3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No credits were charged.`)
};

const de_menuscannocharge3 = /** @type {(inputs: Menuscannocharge3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Es wurden keine Credits abgebucht.`)
};

/**
* | output |
* | --- |
* | "No credits were charged." |
*
* @param {Menuscannocharge3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const menuscannocharge3 = /** @type {((inputs?: Menuscannocharge3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Menuscannocharge3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_menuscannocharge3(inputs)
	return de_menuscannocharge3(inputs)
});
export { menuscannocharge3 as "menuScanNoCharge" }